export default "__VITE_ASSET__M03Lbk6h__"